export interface ZoomTransitionEnablerProps {
  route?: unknown;
}
